import { file, prop, required } from '@rxweb/reactive-form-validators';

export class CompanyClientModel {

    @required()
    name: string;

    //Razon Social
    @required()
    legal_name: string;


    @prop({name: 'address'})
    address: any;
    @prop({name: 'client_id'})
    client_id: any;
    company_client_id: any;
    @prop({name: 'email'})
    email: any;
    @prop({name: 'tax_id'})
    tax_id: any;
    @prop({name: 'contact_name'})
    contact_name: any;
    @prop({name: 'phone_number'})
    phone_number: any;
    @prop({name: 'active'})
    active: any = true;
    @prop({name: 'notes'})
    notes: any;


}
